var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'painted-finger-clue'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('figure', {
    key: _vm.currentKey,
    class: ("keyboard-k2 painted-finger-clue-keys focusable " + (_vm.oneHandedTypingHand ? 'one-hand-typing-hand' : '') + " " + (_vm.isMobile ? 'mobile' : 'desktop') + " " + (_vm.isChromeOS ? 'chrome-os' : '')),
    style: {
      margin: _vm.oneHandedTypingHand ? '0px' : ("0px 0px 0px " + (_vm.marginLeftCurrentKey) + "px")
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('div', {
    class: _vm.currentKey,
    style: {
      backgroundColor: _vm.currentKeyColor
    }
  })]), _c('div', {
    staticClass: "painted-finger-clue-container",
    class: !_vm.showBothHands ? 'painted-one-hand' : '',
    style: {
      visibility: _vm.progress && (_vm.showBothHands || _vm.holdKeyPressed || _vm.oneHandedTypingHand) ? 'visible' : 'hidden'
    }
  }, [_vm.isVisibleLeftHand ? _c('div', {
    class: {
      'painted-finger-clue-left-side': _vm.oneHandedTypingHand ? false : true
    }
  }, [_c('div', {
    staticClass: "svg-image-container current-letter"
  }, [_c('svg', {
    attrs: {
      "width": "200px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.leftHand)
    }
  })])]) : _vm._e(), _vm.isVisibleRightHand ? _c('div', {
    class: {
      'painted-finger-clue-right-side': _vm.oneHandedTypingHand ? false : true
    }
  }, [_c('div', {
    staticClass: "svg-image-container current-letter"
  }, [_c('svg', {
    attrs: {
      "width": "200px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.rightHand)
    }
  })])]) : _vm._e()])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }